import { Trans } from '@lingui/react/macro';
import styles from './IntroducerOnboardingDE.module.css';
import { QualificationGate } from './QualificationGate/QualificationGate';

export const IntroducerOnboardingDE = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        <Trans>Create a partner profile</Trans>
      </h1>
      <p className={styles.intro}>
        <Trans>
          Is your company already a partner of ours? Ask your colleagues for an
          invite link to get started right away.
        </Trans>
      </p>
      <QualificationGate />
    </div>
  );
};
